import { Component } from '@angular/core';

@Component({
    selector: 'app-data-loading',
    templateUrl: './data-loading.component.html',
    styleUrls: ['./data-loading.component.scss'],
    standalone: false
})

export class DataLoadingComponent {
}
